import { Typography } from '@e3dc-react/shell/Elements/Typography'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box } from '@mui/system'
import { useFormikContext } from 'formik'
import React from 'react'
import { Checkbox } from 'src/Libs/inputs/formik'

export interface DeleteProfileFormValues {
  confirmDeletion: boolean
}

const DeleteProfileForm: React.VFC = () => {
  const { handleSubmit } = useFormikContext<DeleteProfileFormValues>()
  const { t } = useCustomTranslation()

  return (
    <>
      <Typography pt={4} pb={2}>
        {t('user.userProfile.dialog.logout-text')}
      </Typography>
      <Box component={'form'} onSubmit={handleSubmit}>
        <Checkbox name={'confirmDeletion'} label={t('user.userProfile.dialog.confirm-deletion')} />
      </Box>
    </>
  )
}

export default DeleteProfileForm
